import { render, staticRenderFns } from "./GuideTooltip.vue?vue&type=template&id=63830e24&scoped=true&lang=pug"
import script from "./GuideTooltip.vue?vue&type=script&lang=ts"
export * from "./GuideTooltip.vue?vue&type=script&lang=ts"
import style0 from "./GuideTooltip.vue?vue&type=style&index=0&id=63830e24&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63830e24",
  null
  
)

export default component.exports